/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2535
 */

var r = require(/* 1448 */"../2523/2524/1448/index")
module.exports = function (e) {
  return function (t) {
    return r(t, e)
  }
}
